import RemoveContactAlert from './RemoveContactAlert';

export default RemoveContactAlert;
